
import React from 'react'
import css from './ReceiptHeader.module.css'
import { ASSET_BASE_URL } from 'config'

const ReceiptHeader = () => (
  <header className={css.main}>
    <h1>
      <a href='/' rel='external'>
        <img src={`${ASSET_BASE_URL}/logos/segment.svg`} alt='Segment' />
      </a>
    </h1>
  </header>
)

export default ReceiptHeader



// WEBPACK FOOTER //
// ./components/ReceiptHeader.js